import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { handleError, handleResponse } from "../utils/handleResponses";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import EndpointFunctions from "../utils/Functions/endpointFunctions";
import { message } from "antd";
import Endpoints from "../api/endpoints";

const UPLOAD_CV_URL = Endpoints.addPersonnelCV;
const GET_PERSONNEL_INFO = Endpoints.getPersonnel;

const DELETE_PERSONNEL_CV =
  "https://hemenpersonel-api.anemotech.com/personnel/user/deletePersonnelCV";

const usePersonnelInfoService = () => {
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();

  const useGetPersonnelInfo = () => {
    return useQuery({
      queryKey: ["personnel"],
      staleTime: Infinity,
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: GET_PERSONNEL_INFO,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
      select: (data) => {
        return data;
      },
    });
  };

  const useUploadCv = () => {
    return useMutation({
      mutationFn: async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        const response = await EndpointFunctions.putData({
          endpointURL: UPLOAD_CV_URL,
          axiosPrivate: axiosPrivate,
          formData: formData,
          isMultiPart: true,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Cv başarıyla yüklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeleteCv = () => {
    return useMutation({
      mutationFn: async () => {
        const response = await EndpointFunctions.deleteWithoutData({
          endpointURL: DELETE_PERSONNEL_CV,
          axiosPrivate: axiosPrivate,
        });
        if (response.status === 200 && response.data.success) {
          return response;
        } else {
          return handleError({ response });
        }
      },
      onSuccess: (response) => {
        message.success("CV Başarıyla Silindi!");
        queryClient.invalidateQueries(["personnel"]);
        return handleResponse({ response });
      },
      onError: (error) => {
        console.log("Error encountered in useDeleteCv:", error);
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- YETKİNLİK EKLEME FONKSİYONLARI----------//

  const useAddPersonnelCourse = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addPersonnelCourse,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Kurs başarıyla yüklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useAddPersonnelSertificate = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addPersonnelCertificate,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Sertifika başarıyla yüklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useAddPersonnelExam = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addPersonnelExam,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Sertifika başarıyla yüklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useAddPersonnelForeignLanguage = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addPersonnelForeignLanguage,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Yabancı Dil Bilgisi başarıyla yüklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useAddPersonnelComputerInformation = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addPersonnelComputerInformation,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Bilgisayar Yetkinliği başarıyla yüklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- YETKİNLİK SİLME FONKSİYONLARI----------//

  const useDeletePersonnelCourse = () => {
    return useMutation({
      mutationFn: async (recordId) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelCourse,
          axiosPrivate: axiosPrivate,
          recordId: recordId,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Kurs başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeletePersonnelCertificate = () => {
    return useMutation({
      mutationFn: async (recordId) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelCertificate,
          axiosPrivate: axiosPrivate,
          recordId: recordId,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Sertifika başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeletePersonnelExam = () => {
    return useMutation({
      mutationFn: async (recordId) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelExam,
          axiosPrivate: axiosPrivate,
          recordId: recordId,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Sertifika başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeletePersonnelForeignLanguage = () => {
    return useMutation({
      mutationFn: async (recordId) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelForeignLanguage,
          axiosPrivate: axiosPrivate,
          recordId: recordId,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Yabancı Dil Bilgisi başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeletePersonnelComputerInformation = () => {
    return useMutation({
      mutationFn: async (recordId) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelComputerInformation,
          axiosPrivate: axiosPrivate,
          recordId: recordId,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Bilgisayar Yetkinliği başarıyla yüklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- YETKİNLİK GÜNCELLEME FONKSİYONLARI----------//

  const useUpdatePersonnelCourse = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.updatePersonnelCourse,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Kurs başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useUpdatePersonnelCertificate = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.updatePersonnelCertificate,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Sertifika başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useUpdatePersonnelExam = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.updatePersonnelExam,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Sertifika başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useUpdatePersonnelForeignLanguage = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.updatePersonnelForeignLanguage,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Yabancı Dil Bilgisi başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useUpdatePersonnelComputerInformation = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.updatePersonnelComputerInformation,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Bilgisayar Yetkinliği başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- EĞİTİM EKLEME GÜNCELLEME SİLME FONKSİYONLARI----------//

  const useAddPersonnelEducation = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addPersonnelEducation,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Eğitim Bilgisi başarıyla eklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useUpdatePersonnelEducation = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.updatePersonnelEducation,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Eğitim Bilgisi başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeletePersonnelEducation = () => {
    return useMutation({
      mutationFn: async (id) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelEducation,
          axiosPrivate: axiosPrivate,
          recordId: id,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Eğitim Bilgisi başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- ONBOARDİNG TAMAMLAMA FONKSİYONU----------//

  const useSetPersonnelOnboarding = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.setOnboarding,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Onboarding  başarıyla tamamlandı!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- DENEYİM EKLEME GÜNCELLEME SİLME FONKSİYONLARI----------//

  const useAddPersonnelExperience = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addPersonnelExperience,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Deneyim başarıyla eklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useUpdatePersonnelExperience = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.updatePersonnelExperience,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Deneyim başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeletePersonnelExperience = () => {
    return useMutation({
      mutationFn: async (id) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelExperience,
          axiosPrivate: axiosPrivate,
          recordId: id,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Deneyim başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- PERSONEL BİLGİ GÜNCELLEME FONKSİYONU----------//
  const useUpdatePersonalInformation = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.setPersonalInformation,
          axiosPrivate: axiosPrivate,
          data: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Profil başarıyla güncellendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- PROFİL FOTOĞRAFI EKLEME - SİLME FONKSİYONLARI----------//
  const useUploadImage = () => {
    return useMutation({
      mutationFn: async (formData) => {
        const response = await EndpointFunctions.putData({
          endpointURL: Endpoints.addImage,
          axiosPrivate: axiosPrivate,
          formData: formData,
          isMultiPart: true,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Profil fotoğrafı başarıyla üklendi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeleteImage = () => {
    return useMutation({
      mutationFn: async () => {
        const response = await EndpointFunctions.deleteData({
          endpointURL: Endpoints.deleteImage,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Profil fotoğrafı başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- CV PREVIEW VE CVPDF GETLEME FONKSİYONLARI----------//
  const useGetCvPreview = () => {
    return useMutation({
      mutationKey: ["cvPreview"],
      mutationFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getCvPreview,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
    });
  };

  const useGetCvPreviewPdf = () => {
    return useMutation({
      mutationKey: ["cvPreviewPdf"],
      mutationFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getCvPreviewPdf,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
    });
  };

  return {
    useGetPersonnelInfo,
    useUploadCv,
    useDeleteCv,
    useAddPersonnelCourse,
    useAddPersonnelSertificate,
    useAddPersonnelExam,
    useAddPersonnelForeignLanguage,
    useAddPersonnelComputerInformation,
    useDeletePersonnelComputerInformation,
    useDeletePersonnelCourse,
    useDeletePersonnelExam,
    useDeletePersonnelForeignLanguage,
    useDeletePersonnelCertificate,
    useUpdatePersonnelCertificate,
    useUpdatePersonnelComputerInformation,
    useUpdatePersonnelCourse,
    useUpdatePersonnelExam,
    useUpdatePersonnelForeignLanguage,
    useAddPersonnelEducation,
    useUpdatePersonnelEducation,
    useDeletePersonnelEducation,
    useSetPersonnelOnboarding,
    useAddPersonnelExperience,
    useDeletePersonnelExperience,
    useUpdatePersonnelExperience,
    useUpdatePersonalInformation,
    useUploadImage,
    useDeleteImage,
    useGetCvPreview,
    useGetCvPreviewPdf,
  };
};

export default usePersonnelInfoService;
